/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * Tenant observation backlog counts (REQ-PIPE-03)
 * @export
 * @interface MdmObservationBacklogResponse
 */
export interface MdmObservationBacklogResponse {
    /**
     * 
     * @type {boolean}
     * @memberof MdmObservationBacklogResponse
     */
    success?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MdmObservationBacklogResponse
     */
    pending?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmObservationBacklogResponse
     */
    resolved?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmObservationBacklogResponse
     */
    stale?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmObservationBacklogResponse
     */
    purged?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmObservationBacklogResponse
     */
    total?: number;
    /**
     * 
     * @type {Date}
     * @memberof MdmObservationBacklogResponse
     */
    asOf?: Date;
    /**
     * 
     * @type {string}
     * @memberof MdmObservationBacklogResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmObservationBacklogResponse
     */
    userTimezone?: string;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof MdmObservationBacklogResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof MdmObservationBacklogResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the MdmObservationBacklogResponse interface.
 */
export function instanceOfMdmObservationBacklogResponse(value: object): value is MdmObservationBacklogResponse {
    return true;
}

export function MdmObservationBacklogResponseFromJSON(json: any): MdmObservationBacklogResponse {
    return MdmObservationBacklogResponseFromJSONTyped(json, false);
}

export function MdmObservationBacklogResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmObservationBacklogResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'pending': json['pending'] == null ? undefined : json['pending'],
        'resolved': json['resolved'] == null ? undefined : json['resolved'],
        'stale': json['stale'] == null ? undefined : json['stale'],
        'purged': json['purged'] == null ? undefined : json['purged'],
        'total': json['total'] == null ? undefined : json['total'],
        'asOf': json['asOf'] == null ? undefined : (new Date(json['asOf'])),
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function MdmObservationBacklogResponseToJSON(json: any): MdmObservationBacklogResponse {
    return MdmObservationBacklogResponseToJSONTyped(json, false);
}

export function MdmObservationBacklogResponseToJSONTyped(value?: MdmObservationBacklogResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'pending': value['pending'],
        'resolved': value['resolved'],
        'stale': value['stale'],
        'purged': value['purged'],
        'total': value['total'],
        'asOf': value['asOf'] == null ? undefined : ((value['asOf']).toISOString()),
        'errorMessage': value['errorMessage'],
        'userTimezone': value['userTimezone'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

